module.exports = __webpack_public_path__ + "img/TRTL.88f653f5.svg";